import React, { useEffect, useState } from "react";
import CustomTypography from "../../components/CustomComponents/CustomTypography/CustomTypography";
import CustomGrid from "../../components/CustomComponents/CustomGrid/CustomGrid";
import DashboardScoreCard from "../../components/DashboardScoreCard/DashboardScoreCard";
import { useStyles } from "../../assets/jss/Dashboard";
import DateTime from "../../components/DateTime/DateTime";
import "../../assets/css/dashboard.css";
import DashboardContentEngagementDial from "../../components/DashboardContentEngagementDial/DashboardContentEngagementDial";
import DashboardContentEngagementGraph from "../../components/DashboardContentEngagementGraph/DashboardContentEngagementGraph";
import DashboardDriverStandard from "../../components/DashboardDriverStandard/DashboardDriverStandard";
import DashboardPenaltyCard from "../../components/DashboardPenaltyCard/DashboardPenaltyCard";
import DashboardDriverAtRisk from "../../components/DashboardDriverAtRisk/DashboardDriverAtRisk";
import { GetDriverScoreStatisticsData } from "../../services/GetDriverScoreStatistics";
import ErrorAlert from "../../components/ErrorAlert/ErrorAlert";
import { Helmet } from "react-helmet";
import {
    setEventType,
    setEventCategory,
    getEventType,
    getEventCategory,
    getUserRBAC,
    checkAPICallDate
} from "../../services/LocalStorageService";
import {
    getEventTypes,
    getEventCategories,
} from "../../services/GetEventTypes";
import { EntityAccess, RBAC_CODE, CacheAPI, APICache } from "../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const Dashboard = React.forwardRef((props: any, ref: any) => {
    const params = useParams();
    const { t } = useTranslation();
    const classes = useStyles();
    const [getRBAC_ScoreCardView] = React.useState(
        getUserRBAC(RBAC_CODE.SCORE_CARD_VIEW, props)
    );
    const [getRBAC_EngagementCardView] = React.useState(
        getUserRBAC(RBAC_CODE.ENGAGEMENT_CARD_VIEW, props)
    );
    const [getRBAC_DriverAtRiskCardView] = React.useState(
        getUserRBAC(RBAC_CODE.DRIVER_AT_RISK_CARD_VIEW, props)
    );
    const [getRBAC_DriverStandardCardView] = React.useState(
        getUserRBAC(RBAC_CODE.DRIVER_STANDARD_CARD_VIEW, props)
    );
    const [getRBAC_CE_GraphView] = React.useState(
        getUserRBAC(RBAC_CODE.CE_GRAPH_VIEW, props)
    );
    const [getRBAC_PenaltyPointCardView] = React.useState(
        getUserRBAC(RBAC_CODE.PENALTY_POINT_CARD_VIEW, props)
    );
    const [isMounted, setIsMounted] = React.useState(null);
    const [currentDate, setAPICallDate] = React.useState(new Date());
    const [scoreCard, setScoreCard] = React.useState(null);
    const [isApi, setIsApi] = React.useState(false);
    const [praisoScore, setPraisoScore] = React.useState(null);
    const [brakingScore, setBrakingScore] = React.useState(null);
    const [corneringScore, setCorneringScore] = React.useState(null);
    const [accelerationScore, setAccelerationScore] = React.useState(null);
    const [speedingScore, setSpeedingScore] = React.useState(null);
    const [engagementScore, setEngagementScore] = React.useState(null);
    const [distractionScore, setDistractionScore] = React.useState(null);
    const [eventTypes, setEventTypes] = React.useState(null);
    const [isApiFailed, setIsApiFailed] = React.useState(false);
    const [googleAnalyticsId] = useState(process.env.REACT_APP_GOOGLE_TAG_ID);
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    useEffect(() => {
        async function getEventtypes() {
            const data = await getEventTypes(params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setEventTypes(data.content);
                setEventType(data.content);
            } else {
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }

        async function getEventCategoriesFromAPI() {
            const data = await getEventCategories(params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setEventCategory(data.content);
            } else {
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }

        async function getDriverScoreStatistics() {
            setStatusValue(null);
            setAlertMessage("");
            setIsAlertOpen(false);
            setIsApi(true);
            const data = await GetDriverScoreStatisticsData(params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsApi(false);
                setIsApiFailed(false);
                setScoreCard(
                    data.content && data.content.eventScores && data.content.eventScores
                );
                let url = APICache.DASHBOARD_API;
                if (params.impersonationid) {
                    url = `${url}&${params.impersonationid}`
                }
                setAPICallDate(checkAPICallDate(url));
            } else {
                setIsApi(false);
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }

        if (isMounted === null && !isApiFailed) {
            setIsMounted(true);
            const eventTypeLocal = getEventType();
            if (eventTypeLocal && eventTypeLocal.length) {
                setEventTypes(eventTypeLocal);
            } else {
                getEventtypes();
            }

            const eventCatLocal = getEventCategory();
            if (!eventCatLocal || !eventCatLocal.length) {
                //getEventCategory();
                getEventCategoriesFromAPI();
            }
            getDriverScoreStatistics();
        }
        setIsMounted(false);
    }, []);

    React.useEffect(() => {
        if (
            scoreCard &&
            scoreCard.length > 0 &&
            eventTypes &&
            eventTypes.length > 0
        ) {
            for (let i = 0; i < scoreCard.length; i++) {
                const eventType = eventTypes.find(
                    (event) => event.id === scoreCard[i].scoreTypeId
                );
                if (eventType.code === "PRAISOSCORE") {
                    setPraisoScore({
                        ...scoreCard[i],
                        eventCode: eventType.code,
                        eventName: eventType.name,
                    });
                } else if (eventType.code === "BRAKING") {
                    setBrakingScore({
                        ...scoreCard[i],
                        eventCode: eventType.code,
                        eventName: eventType.name,
                    });
                } else if (eventType.code === "CORNERING") {
                    setCorneringScore({
                        ...scoreCard[i],
                        eventCode: eventType.code,
                        eventName: eventType.name,
                    });
                } else if (eventType.code === "ACCELERATION") {
                    setAccelerationScore({
                        ...scoreCard[i],
                        eventCode: eventType.code,
                        eventName: eventType.name,
                    });
                } else if (eventType.code === "SPEEDING") {
                    setSpeedingScore({
                        ...scoreCard[i],
                        eventCode: eventType.code,
                        eventName: eventType.name,
                    });
                } else if (eventType.code === "ENGAGEMENT") {
                    setEngagementScore({
                        ...scoreCard[i],
                        eventCode: eventType.code,
                        eventName: eventType.name,
                    });
                } else if (eventType.code === "DISTRACTION") {
                    setDistractionScore({
                        ...scoreCard[i],
                        eventCode: eventType.code,
                        eventName: eventType.name,
                    });
                }
            }
        }
    }, [scoreCard, eventTypes]);

    return (
        <>
            <CustomGrid container spacing={0} justifyContent="space-between">
                <CustomGrid item>
                    <CustomTypography
                        component="h1"
                        variant="h5"
                        className={classes.headingTitle}
                    >
                        {t("DASHBOARD")}
                    </CustomTypography>
                </CustomGrid>
                <CustomGrid item>
                    <CustomTypography
                        className={classes.headerSubNote}
                        component="p"
                        variant="h6"
                    >
                        {t("LAST_UPDATED_ON")}{" "}
                        <DateTime inputDate={currentDate} returnFormat="ddd" />,{" "}
                        <DateTime inputDate={currentDate} returnFormat="DD MMM YYYY" /> |{" "}
                        <DateTime inputDate={currentDate} returnFormat="hh:mm a" />
                    </CustomTypography>
                </CustomGrid>
            </CustomGrid>
            <CustomGrid container spacing={4}>
                <CustomGrid item xs={12}>
                    <CustomGrid container spacing={2}>
                        {getRBAC_ScoreCardView &&
                            getRBAC_ScoreCardView.isAccessible === EntityAccess.ALLOWED ? (
                            <CustomGrid item xs={12} lg={6}>
                                <DashboardScoreCard
                                    praisoScore={praisoScore}
                                    brakingScore={brakingScore}
                                    corneringScore={corneringScore}
                                    accelerationScore={accelerationScore}
                                    speedingScore={speedingScore}
                                    engagementScore={engagementScore}
                                    distractionScore={distractionScore}
                                    isApi={isApi}
                                    isApiFailed={isApiFailed}
                                    {...props}
                                />
                            </CustomGrid>
                        ) : null}
                        {getRBAC_EngagementCardView &&
                            getRBAC_EngagementCardView.isAccessible === EntityAccess.ALLOWED ? (
                            <CustomGrid item xs={12} lg={6}>
                                <DashboardContentEngagementDial
                                    isApi={isApi}
                                    engagementScore={engagementScore}
                                    {...props}
                                />
                            </CustomGrid>
                        ) : null}
                    </CustomGrid>
                </CustomGrid>
            </CustomGrid>
            {getRBAC_DriverAtRiskCardView &&
                getRBAC_DriverAtRiskCardView.isAccessible === EntityAccess.ALLOWED ? (
                <CustomGrid container spacing={4}>
                    <CustomGrid item xs={12} className={classes.accordionContainer}>
                        <DashboardDriverAtRisk {...props} />
                    </CustomGrid>
                </CustomGrid>
            ) : null}
            <CustomGrid container spacing={4}>
                <CustomGrid item xs={12}>
                    <CustomGrid container spacing={2}>
                        {getRBAC_CE_GraphView &&
                            getRBAC_CE_GraphView.isAccessible === EntityAccess.ALLOWED ? (
                            <CustomGrid item xs={12} lg={7}>
                                <DashboardContentEngagementGraph {...props} />
                            </CustomGrid>
                        ) : null}
                        {getRBAC_DriverStandardCardView &&
                            getRBAC_DriverStandardCardView.isAccessible ===
                            EntityAccess.ALLOWED ? (
                            <CustomGrid item xs={12} lg={5}>
                                <DashboardDriverStandard {...props} />
                            </CustomGrid>
                        ) : null}
                    </CustomGrid>
                </CustomGrid>
            </CustomGrid>
            {getRBAC_PenaltyPointCardView &&
                getRBAC_PenaltyPointCardView.isAccessible === EntityAccess.ALLOWED ? (
                <CustomGrid container spacing={4}>
                    <CustomGrid item xs={12}>
                        <DashboardPenaltyCard 
                            eventTypes={eventTypes} 
                            eventCode={"SPEEDING_AND_DISTRACTION"}
                        />
                    </CustomGrid>
                </CustomGrid>
            ) : null}

            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
            <Helmet>
                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
                ></script>
                <script>
                    {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', "${googleAnalyticsId}");
        `}
                </script>
            </Helmet>
        </>
    );
});

export default Dashboard;
